import State from '../core/State';
import Account from '../entity/Account';
import AcctAccount from '../entity/AcctAccount';
import BfOrganization from '../entity/BfOrganization';
import Invitation from '../entity/Invitation';
import Membership from '../entity/Membership';
import Organization from '../entity/Organization';
import initialState from '../initialState';

export const setOrganizations = (organizations: Organization[], current: Organization | null) => (
  state: State,
): State => {
  return {
    ...state,
    organization: {
      ...state.organization,
      organizations,
    },
    currentOrgOrAccount: current,
    organizationFetched: true,
  };
};

export const setCurrentOrgOrAccount = (organization: Organization) => (state: State): State => {
  // TODO: 一旦accoutとorgのidが同じ前提
  let currentAcctAccount = state.currentAcctAccount;
  let currentAccount = state.organization.account;
  let currentBfOrganization = state.currentBfOrganization;
  const acct = state.acct;
  let bf = state.bf;
  if (!state.currentOrgOrAccount || (state.currentOrgOrAccount && state.currentOrgOrAccount.id != organization.id)) {
    currentAcctAccount = null;
    currentAccount = null;
    currentBfOrganization = null;
    acct.billUser = initialState.acct.billUser;
    acct.productPricing = initialState.acct.productPricing;
    bf = initialState.bf;
  }

  return {
    ...state,
    currentOrgOrAccount: organization,
    currentAcctAccount,
    currentBfOrganization,
    organization: {
      ...state.organization,
      memberships: initialState.organization.memberships,
      account: currentAccount,
    },
    acct,
    bf,
  };
};

export const startFetchingOrganization = () => (state: State): State => ({
  ...state,
  organizationFetched: false,
});

export const setCurrentAcctAccount = (account: AcctAccount) => (state: State): State => ({
  ...state,
  currentAcctAccount: account,
});
export const setCurrentAcctAccountLoading = (bool: boolean) => (state: State): State => ({
  ...state,
  currentAcctAccountLoading: bool,
});

export const setCurrentBfOrganization = (organization: BfOrganization) => (state: State): State => ({
  ...state,
  currentBfOrganization: organization,
});
export const setCurrentBfOrganizationLoading = (bool: boolean) => (state: State): State => ({
  ...state,
  currentBfOrganizationLoading: bool,
});

export const startLoadingOrganizationMemberships = () => (state: State): State => ({
  ...state,
  organization: {
    ...state.organization,
    memberships: {
      ...state.organization.memberships,
      spinnerNecessity: state.organization.memberships.spinnerNecessity + 1,
    },
  },
});

export const setCurrentOrganizationMemberships = (organizationId: string, memberships: Membership[]) => (
  state: State,
): State => {
  if (state.currentOrgOrAccount && state.currentOrgOrAccount.id == organizationId) {
    return {
      ...state,
      organization: {
        ...state.organization,
        memberships: {
          ...state.organization.memberships,
          memberships,
          spinnerNecessity: 0,
        },
      },
    };
  } else {
    return {
      ...state,
    };
  }
};

export const updateMembership = (membership: Membership) => (state: State): State => {
  const memberships = Array<Membership>();
  (state.organization.memberships.memberships || []).forEach((m: Membership) =>
    memberships.push(m.id === membership.id ? membership : m),
  );
  return {
    ...state,
    organization: {
      ...state.organization,
      memberships: {
        ...state.organization.memberships,
        memberships,
      },
    },
  };
};

export const deleteMembership = (id: string) => (state: State): State => {
  return {
    ...state,
    organization: {
      ...state.organization,
      memberships: {
        ...state.organization.memberships,
        memberships: (state.organization.memberships.memberships || []).filter(m => m.id !== id),
      },
    },
  };
};

export const setCurrentOrganizationInvitations = (invitations: Invitation[]) => (state: State): State => ({
  ...state,
  organization: {
    ...state.organization,
    memberships: {
      ...state.organization.memberships,
      invitations,
    },
  },
});

export const setAccount = (account: Account) => (state: State): State => ({
  ...state,
  organization: {
    ...state.organization,
    account,
  },
});

export const disposeOrganization = () => (state: State): State => ({
  ...state,
  organization: {
    ...initialState.organization,
  },
  currentOrgOrAccount: initialState.currentOrgOrAccount,
  currentAcctAccount: initialState.currentAcctAccount,
  currentAcctAccountLoading: initialState.currentAcctAccountLoading,
});
